// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"310":"c7f47bc338dcfb4c","2722":"0f79dbe9ea1e3c77","3877":"fe336940f98fdfab","6245":"975268176772414e","7584":"d9652db206d50763","9755":"9dafb5a1266bf55d"}[chunkId] + ".css";
};